import { render, staticRenderFns } from "./CreateCreativeCompany.vue?vue&type=template&id=72786526&"
import script from "./CreateCreativeCompany.vue?vue&type=script&lang=js&"
export * from "./CreateCreativeCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports